export function OpenPopup(openType, newState, props) {
    return {
        type: 'POPUP_OPEN', 
        payload: { 
            type: openType, 
            state: newState, 
            properties: props 
        }
    };
}

export function UpdatePopupProps(typeValidation, props) {
    return {
        type: 'POPUP_UPDATE_PROPS', 
        payload: { 
            type: typeValidation,
            properties: props 
        }
    };
}

export function CloseActivePopup() {
    return {
        type: 'POPUP_CLOSE_ACTIVE'
    };
}